module.exports = __webpack_public_path__ + "static/media/ic_view_eye.0f96da38.svg";